export default "__VITE_ASSET__B8C7EbRN__"